import { TronWeb } from 'tronweb';

/**
 * 校验是否为合法的 TRON Base58Check 地址（T 开头且校验和有效）
 */
export function isValidTronAddress(address: unknown): boolean {
  if (!address || typeof address !== 'string') {
    return false;
  }
  const trimmed = address.trim();
  // 必须是 T 开头的 34 位 Base58 地址
  if (!trimmed.startsWith('T') || trimmed.length !== 34) {
    return false;
  }
  try {
    return TronWeb.isAddress(trimmed);
  } catch {
    return false;
  }
}

/**
 * Tron 能量接收地址前4后4缩略展示
 */
export function shortenTronAddress(address?: string | null): string {
  if (!address || typeof address !== 'string') {
    return '-';
  }
  const trimmed = address.trim();
  if (trimmed.length <= 10) {
    return trimmed;
  }
  return `${trimmed.slice(0, 4)}...${trimmed.slice(-4)}`;
}
